import { render } from "./image-text-overlay.vue?vue&type=template&id=08a77868"
import script from "./image-text-overlay.vue?vue&type=script&lang=js"
export * from "./image-text-overlay.vue?vue&type=script&lang=js"

import "./image-text-overlay.vue?vue&type=style&index=0&id=08a77868&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__